export default __webpack_public_path__ + "static/media/bank.e1661b09.svg";